import { Component, Input } from '@angular/core';
import { MinimalPatientAttachment } from 'app/core/models/minimal-patient-attachment.model';


@Component({
    selector: 'app-patient-attachment-duplicate',
    templateUrl: './patient-attachment-duplicate.component.html',
    styleUrl: './patient-attachment-duplicate.component.scss',
    imports: []
})
export class PatientAttachmentDuplicateComponent {
  @Input() patientAttachment: MinimalPatientAttachment;
}
